/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { COMMUNICATIONS: de },
  'el-GR': { COMMUNICATIONS: el },
  'en-US': { COMMUNICATIONS: en },
  'es-ES': { COMMUNICATIONS: es },
  'fi-FI': { COMMUNICATIONS: fi },
  'fr-FR': { COMMUNICATIONS: fr },
  'it-IT': { COMMUNICATIONS: it },
  'pl-PL': { COMMUNICATIONS: pl },
  'pt-PT': { COMMUNICATIONS: pt }
};
